import { render, staticRenderFns } from "./set-all.vue?vue&type=template&id=56d2a9ea&scoped=true&"
import script from "./set-all.vue?vue&type=script&lang=js&"
export * from "./set-all.vue?vue&type=script&lang=js&"
import style0 from "./set-all.vue?vue&type=style&index=0&id=56d2a9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2a9ea",
  null
  
)

export default component.exports